import React from "react";
type PageTitleProps = {
  title: string
}
export default function PageTitle(pageTitleProps: PageTitleProps){
  return(
    <div className="page-title">
      <div className="container">
          <div className="row">
              <div className="col-md-12">
                  <div className="page-title-heading">
                    <h1 className="h1-title">{pageTitleProps.title}</h1>      
                  </div>
                  <div className="clearfix"></div>
              </div>
          </div>
      </div>
    </div>
  );
};